import React from 'react';
import { Tooltip } from '@mui/material';

const TYPE_META = {
    bounce: { label: 'Hard bounce', color: '#c62828' },
    espblock: { label: 'Blocked', color: '#e65100' },
    blacklisted: { label: 'Blacklisted', color: '#b71c1c' },
    'suppress-complaint': { label: 'Spam complaint', color: '#6a1b9a' },
    overquota: { label: 'Mailbox full', color: '#f57c00' },
    generic: { label: 'Delivery failed', color: '#616161' },
    old: { label: 'DNS failure', color: '#616161' },
    'suppress-bounce': { label: 'Suppressed', color: '#9e9e9e' },
};

function BounceReasonCell({ reason }) {
    if (!reason) return <span style={{ color: '#bbb' }}>—</span>;

    const { type, message, suppress_count } = reason;
    const { label, color } = TYPE_META[type] || { label: type, color: '#616161' };

    return (
        <div style={{ lineHeight: '1.4' }}>
            <span
                style={{
                    display: 'inline-block',
                    fontSize: 11,
                    fontWeight: 600,
                    letterSpacing: '0.03em',
                    textTransform: 'uppercase',
                    color,
                    background: color + '18',
                    borderRadius: 3,
                    padding: '1px 5px',
                    marginBottom: 3,
                }}
            >
                {label}
            </span>
            <Tooltip title={message} placement="top">
                <div
                    style={{
                        fontSize: 13,
                        color: '#444',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 210,
                        cursor: 'default',
                    }}
                >
                    {message}
                </div>
            </Tooltip>
            {suppress_count > 0 && (
                <div style={{ fontSize: 11, color: '#9e9e9e', marginTop: 1 }}>
                    +{suppress_count} suppressed
                </div>
            )}
        </div>
    );
}

export default BounceReasonCell;
